module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('p', [_vm._v("评论列表中的回复框是互斥的，且点击空白处消失")]), _vm._v(" "), _vm._l((5), function(n, index) {
    return _c('comment-item', {
      key: index
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa93e59","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/App.vue
// module id = 16
// module chunks = 0